"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePayInAmount = void 0;
const formatCurrency_1 = require("../../../utils/format/formatCurrency");
function validatePayInAmount(startAmount, liquidCapital, isUnderage) {
    const minLiquidCapital = Math.round(startAmount * 1.26);
    if (liquidCapital === 0)
        return isUnderage
            ? "Bitte geben Sie das liquide Vermögen Ihres Kindes an."
            : "Bitte geben Sie Ihr liquides Vermögen an.";
    if (liquidCapital < minLiquidCapital)
        return isUnderage
            ? `Das liquide Vermögen Ihres Kindes muss bei einer Einzahlung von ${(0, formatCurrency_1.default)(startAmount)} mindestens ${(0, formatCurrency_1.default)(minLiquidCapital)} (126% vom Einzahlbetrag) betragen. Möchten Sie das liquide Vermögen Ihres Kindes ändern?`
            : `Ihr liquides Vermögen muss bei einer Einzahlung von ${(0, formatCurrency_1.default)(startAmount)} mindestens ${(0, formatCurrency_1.default)(minLiquidCapital)} (126% vom Einzahlbetrag) betragen. Möchten Sie Ihr liquides Vermögen ändern?`;
    return undefined;
}
exports.validatePayInAmount = validatePayInAmount;
